import ErrorFeedbackScreen from '../../components/shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import ErrorRoundImage from '../../assets/images/error-round.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import { useEffect } from 'preact/hooks';
import useTranslation from '../../localization/i18n.context';
import NavigationUtils from '../../utils/navigation.utils';
import OnboardingStatusUrlUtils from '../../utils/onboarding-status-url.utils';
import { TrackingEvent } from '../../sdk/tracking.event';

const OnboardingErrorConfig = {
  [OnboardingStatusUrlUtils.OnboardingErrorType.INFORMATION_MISMATCH]: {
    image: ErrorRoundImage,
    title: "The ID you entered doesn't match the one provided by your company",
    text: 'Please contact your card provider or try again',
    ctaText: 'Try Again',
    eventName: 'information_mismatch',
    ctaAction: () => {
      NavigationUtils.navigate(NavigationUtils.Routes.ONBOARDING);
    },
    onCloseClick: () => {
      CloseWebviewEvent.finishWithError();
    },
  },
  [OnboardingStatusUrlUtils.OnboardingErrorType.UNDERAGED]: {
    image: ErrorRoundImage,
    title: "It looks like you're underage",
    text: 'You need to be 18+ to apply for {card name} card',
    ctaText: 'Ok',
    eventName: 'under_age',
    ctaAction: () => {
      CloseWebviewEvent.finishWithError();
    },
    onCloseClick: () => {
      CloseWebviewEvent.finishWithError();
    },
  },
  [OnboardingStatusUrlUtils.OnboardingErrorType.REJECTED]: {
    image: ErrorRoundImage,
    title: 'Hmmm...',
    text: "It looks like we can't approve your {card name} card application right now",
    ctaText: 'Ok',
    eventName: 'rejected',
    ctaAction: () => {
      CloseWebviewEvent.finishWithError();
    },
    onCloseClick: () => {
      CloseWebviewEvent.finishWithError();
    },
  },
};

export default function OnboardingErrorPage({
  type,
  organization: organizationCode,
}) {
  const { t, getOrganization } = useTranslation();

  const data = OnboardingErrorConfig[type];

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.ONBOARDING_ERROR_SHOW,
      TrackingEvent.Sources.CAAS,
      {
        status: data.eventName,
      },
    );
  }, [type]);

  return (
    <>
      {data && (
        <ErrorFeedbackScreen
          onCloseClick={data.onCloseClick}
          image={data.image}
          title={t(data.title, {
            '{card name}': getOrganization(organizationCode),
          })}
          text={t(data.text, {
            '{card name}': getOrganization(organizationCode),
          })}
          ctaAction={data.ctaAction}
          ctaText={t(data.ctaText)}
        />
      )}
    </>
  );
}
